const PreviewDocuments = ({ source = '', title, type = 'local' }) => {
  let src = `https://docs.google.com/viewer?url=${source}&embedded=true`
  if (type === 'google') {
    src = `https://docs.google.com/viewerng/viewer?url=${source}&embedded=true&a=gt`
  }
  if (type === 'microsoft') {
    src = `https://view.officeapps.live.com/op/embed.aspx?src=${source}`
  }


  if (type === 'local') {
    return (
      <object className="w-100 h-100" data={source}>
        <iframe
          onContextMenu={(e) => e.preventDefault()}
          frameborder="0"
          height="100%"
          width="100%"
          src={src}
          title={title}
        />
      </object>
    )
  } else {
    return (
      <iframe
        onContextMenu={(e) => e.preventDefault()}
        frameborder="0"
        height="100%"
        width="100%"
        title={title}
        src={src}
      />
    )
  }

}

export default PreviewDocuments